import { ThemeEvents, VariantUpdateEvent } from '@theme/events';
import { morph } from '@theme/morph';

class OosUkRedirect extends HTMLElement {
  connectedCallback() {
    this.closestSection = this.closest('.shopify-section, dialog');
    this.closestSection?.addEventListener(ThemeEvents.variantUpdate, this.updateRedirect);
  }

  disconnectedCallback() {
    this.closestSection?.removeEventListener(ThemeEvents.variantUpdate, this.updateRedirect);
    this.closestSection = null;
  }

  /**
   * Swaps the block's contents to match the newly selected variant.
   * @param {VariantUpdateEvent} event - The variant update event.
   */
  updateRedirect = (event) => {
    if (event.detail.data.newProduct) {
      this.dataset.productId = event.detail.data.newProduct.id;
    } else if (event.target instanceof HTMLElement && event.target.dataset.productId !== this.dataset.productId) {
      return;
    }

    const newRedirect = event.detail.data.html.querySelector('oos-uk-redirect');

    if (!newRedirect) return;

    morph(this, newRedirect, { childrenOnly: true });
  };
}

if (!customElements.get('oos-uk-redirect')) {
  customElements.define('oos-uk-redirect', OosUkRedirect);
}
